/**
 * @file コンポーネント：フル動画コンテンツ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledContents = styled.div`
    display: flex;
    margin-top: 96px;

    ${mediaQuery.pc(`
        height: calc(100vh - 96px);
    `)};

    ${mediaQuery.pcWide(`
        height: calc(100vh - 96px);
    `)};

    &[data-focus-note="true"] {
        margin-top: 0;

        ${mediaQuery.pc(`
            height: 100vh;
        `)};

        ${mediaQuery.pcWide(`
            height: 100vh;
        `)};
    }
`;

export const StyledContentsData = styled.div`
    position: relative;

    ${mediaQuery.sp(`
        width: 100%;
        overflow-y: auto;
    `)};

    ${mediaQuery.spWide(`
        width: 100%;
        overflow-y: auto;
    `)};

    ${mediaQuery.tablet(`
        width: 100%;
        overflow-y: auto;
    `)};

    ${mediaQuery.pc(`
        width: 75%;
        overflow-y: auto;
    `)};

    ${mediaQuery.pcWide(`
        width: 75%;
        overflow-y: auto;
    `)};
`;

export const StyledContentsDataLoading = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${zIndex.fullvideoContentsDataLoading};
    width: 100%;
    height: 100%;
    background-color: #25292d;
`;
